import { FC } from "react";
import {
  Blocks,
  BuilderBlock,
  BuilderContextInterface,
  RegisteredComponents,
} from "@builder.io/sdk-react";
import GlobalFooter from "@/components/GlobalFooter/GlobalFooter";
import { BuilderBlockProps, Theme } from "@/types";
import { Link as LinkProps } from "@/types/General/Link";

type GlobalFooterBlockProps = {
  isRedesigned?: boolean;
  logo?: BuilderBlock[];
  description: BuilderBlock[];
  links: Array<{
    link_category?: string;
    link: Array<LinkProps>;
  }>;
  theme?: Theme;
  socialsText?: BuilderBlock[];
  socials?: Array<{
    link: LinkProps;
    icon?: BuilderBlock[];
  }>;
  cta: BuilderBlock[];
  builderBlock: BuilderBlock;
  builderComponents: RegisteredComponents;
  builderLinkComponent: unknown;
  builderContext: BuilderContextInterface;
} & BuilderBlockProps;

export const GlobalFooterBlock: FC<GlobalFooterBlockProps> = ({
  isRedesigned = false,
  description,
  links,
  cta,
  logo,
  theme,
  socials,
  socialsText,
  builderBlock,
  builderComponents,
  builderLinkComponent,
  builderContext,
}) => {
  return (
    <GlobalFooter
      isRedesigned={isRedesigned}
      description={
        <Blocks
          parent={builderBlock?.id}
          blocks={description}
          path="description"
          registeredComponents={builderComponents}
          linkComponent={builderLinkComponent}
          context={builderContext}
        />
      }
      links={links}
      cta={
        <Blocks
          parent={builderBlock?.id}
          blocks={cta}
          path="cta"
          registeredComponents={builderComponents}
          linkComponent={builderLinkComponent}
          context={builderContext}
          className="w-full"
        />
      }
      logo={
        logo ? (
          <Blocks
            parent={builderBlock?.id}
            blocks={logo}
            path="logo"
            registeredComponents={builderComponents}
            linkComponent={builderLinkComponent}
            context={builderContext}
          />
        ) : undefined
      }
      theme={theme}
      socialsText={
        socialsText ? (
          <Blocks
            parent={builderBlock?.id}
            blocks={socialsText}
            path="socialsText"
            registeredComponents={builderComponents}
            linkComponent={builderLinkComponent}
            context={builderContext}
          />
        ) : undefined
      }
      socials={socials?.map((social, index) => ({
        link: social.link,
        icon: social.icon ? (
          <Blocks
            key={index}
            parent={builderBlock?.id}
            blocks={social.icon}
            path={`socials.${index}.icon`}
            registeredComponents={builderComponents}
            linkComponent={builderLinkComponent}
            context={builderContext}
          />
        ) : undefined,
      }))}
    />
  );
};
